import React from 'react';

import { AccountMenuButton } from '@wetransfer/transfer/component/AccountMenu/AccountMenuButton/AccountMenuButton';
import { useCurrentTeam } from '@wetransfer/transfer/hooks/useCurrentTeam/useCurrentTeam';
import Store from '@wetransfer/transfer/store';

import './TransferAccountMenuButton.scss';

import Helper from '@wetransfer/transfer/helper';

export interface Props {
  showLabel: boolean;
  avatarURL: string;
  menuLabel: string;
  language: string;
}

const MenuButton: React.ForwardRefRenderFunction<HTMLButtonElement, Props> = (
  { showLabel, menuLabel, avatarURL, language, ...restProps },
  ref
) => {
  const style = { backgroundImage: `url(${avatarURL})` };
  const nameClassList = `TransferAccountMenuButton__name TransferAccountMenuButton__name-${language}`;
  const { user } = Store.getState();

  const { currentTeam } = useCurrentTeam();

  return (
    <button ref={ref} className="TransferAccountMenuButton" {...restProps}>
      {showLabel && (
        <span className={nameClassList} title={menuLabel}>
          {Helper.getWorkspaceName(currentTeam, user)}
        </span>
      )}
      <span
        className="TransferAccountMenuButton__avatar"
        style={{ ...style, borderRadius: '5px' }}
      />
    </button>
  );
};
const MenuButtonRef = React.forwardRef<HTMLButtonElement, Props>(MenuButton);

export const TransferAccountMenuButton: React.FC<Props> = React.memo(
  (props) => <AccountMenuButton as={MenuButtonRef} {...props} />
);
TransferAccountMenuButton.displayName = 'TransferAccountMenuButton';
